module.exports = __webpack_public_path__ + "img/XLJK.d701aea9.png";